import { useEffect } from 'react';
import Logger from '@medflex/utils/Logger';

const useUnloadWarning = isUploading => {
  useEffect(() => {
    const handleUnload = event => {
      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = '';
    };
    if (isUploading) {
      window.addEventListener('beforeunload', handleUnload);
      Logger.log('[unloadWarning] unload warning bound to window');
    }
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
      Logger.log('[unloadWarning] unload warning unbound from window');
    };
  }, [isUploading]);
};

export default useUnloadWarning;
